import React, { Component } from "react";
import { Droppable, Draggable } from "react-beautiful-dnd";
import classNames from "classnames";
import './style.scss'
class WasteBasket extends Component {

  handleClasses = (snapshot) => {
    const classes = classNames("TrashDraggable", {
      isDragging: snapshot.isDragging,
      notDragging: !snapshot.isDragging,
    });
    return classes;
  };

  render() {
    return (
      <Droppable droppableId="trash">
        {(provided, snapshot) => (
          <div
            ref={provided.innerRef}
            className={
              snapshot.isDraggingOver
                ? "WasteBasket dropping"
                : "WasteBasket"
            }
          >
            <Draggable draggableId="trashIcon" index={1} isDragDisabled={true}>
              {(provided, snapshot) => (
                <div
                  ref={provided.innerRef}
                  {...provided.draggableProps}
                  {...provided.dragHandleProps}
                  className={this.handleClasses(snapshot)}
                >
                  <div className='TrashIcon'/>
                </div>
              )}
            </Draggable>
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    );
  }
}

export default WasteBasket;
